/* VyomTara | Bottom Nav Bar + Category Drawer — standalone, no shared globals */
(function () {
  if (window.customElements && customElements.get('vt-bottom-nav')) return;

  function cleanPath(url) {
    if (!url) return '/';
    try {
      var a = document.createElement('a');
      a.href = url;
      var p = a.pathname || '/';
      if (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
      return p || '/';
    } catch (e) {
      return '/';
    }
  }

  class VTBottomNav extends HTMLElement {
    connectedCallback() {
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-vt-bn-item]'));
      this.counts = Array.prototype.slice.call(this.querySelectorAll('[data-vt-bn-count]'));
      this.opener = this.querySelector('[data-vt-bn-open]');

      this.markActive();
      if (this.counts.length) this.watchCart();
      if (this.opener) this.wireDrawer();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.closeDrawer();
    }

    /* ---------- active state ---------- */
    markActive() {
      var here = cleanPath(window.location.pathname);
      var best = null;
      var bestLen = -1;

      for (var i = 0; i < this.items.length; i++) {
        var raw = this.items[i].getAttribute('data-vt-bn-path');
        if (!raw) continue;
        var p = cleanPath(raw);
        var hit = p === here || (p !== '/' && here.indexOf(p + '/') === 0);
        if (hit && p.length > bestLen) {
          best = this.items[i];
          bestLen = p.length;
        }
      }

      for (var j = 0; j < this.items.length; j++) {
        this.items[j].classList.toggle('is-active', this.items[j] === best);
      }
    }

    /* ---------- cart badge ---------- */
    setCount(n) {
      for (var i = 0; i < this.counts.length; i++) {
        this.counts[i].textContent = n;
        this.counts[i].hidden = !(n > 0);
      }
    }

    refreshCart() {
      var self = this;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && typeof c.item_count === 'number') self.setCount(c.item_count); })
        .catch(function () {});
    }

    watchCart() {
      var self = this;
      var timer = null;
      var bump = function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () { timer = null; self.refreshCart(); }, 350);
      };

      document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('[type="submit"], form[action*="/cart"], [name="add"], [data-vt-bn-refresh]')) bump();
      }, true);

      document.addEventListener('cart:updated', bump);
      document.addEventListener('cart-drawer:open', bump);

      var bubble = document.getElementById('cart-icon-bubble') || document.querySelector('.cart-count-bubble');
      if (bubble && window.MutationObserver) {
        this.observer = new MutationObserver(bump);
        this.observer.observe(bubble, { childList: true, subtree: true, characterData: true });
      }

      window.addEventListener('pageshow', function (e) { if (e.persisted) self.refreshCart(); });
      this.refreshCart();
    }

    /* ---------- category drawer ---------- */
    wireDrawer() {
      var id = this.opener.getAttribute('aria-controls');
      this.drawer = id ? document.getElementById(id) : null;
      if (!this.drawer) return;

      var self = this;

      this.opener.addEventListener('click', function (e) {
        e.preventDefault();
        self.drawer.hidden ? self.openDrawer() : self.closeDrawer();
      });

      this.drawer.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;

        if (t.closest('[data-vt-bn-close]')) {
          e.preventDefault();
          self.closeDrawer();
          return;
        }

        var tog = t.closest('[data-vt-bn-toggle]');
        if (tog) {
          e.preventDefault();
          var row = tog.closest('.vt-bn-dw__item');
          var sub = row && row.querySelector('[data-vt-bn-sub]');
          if (!sub) return;
          var open = sub.hidden;
          sub.hidden = !open;
          tog.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      });

      this.onKey = function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) self.closeDrawer();
      };
    }

    openDrawer() {
      if (!this.drawer) return;
      this.drawer.hidden = false;
      // let the browser paint the hidden state before animating in
      var d = this.drawer;
      if (window.requestAnimationFrame) {
        requestAnimationFrame(function () { d.classList.add('is-open'); });
      } else {
        d.classList.add('is-open');
      }
      document.documentElement.classList.add('vt-bn-lock');
      this.opener.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', this.onKey);

      var close = this.drawer.querySelector('.vt-bn-dw__close');
      if (close && close.focus) { try { close.focus(); } catch (e) {} }
    }

    closeDrawer() {
      if (!this.drawer || this.drawer.hidden) return;
      var d = this.drawer;
      d.classList.remove('is-open');
      document.documentElement.classList.remove('vt-bn-lock');
      if (this.opener) this.opener.setAttribute('aria-expanded', 'false');
      if (this.onKey) document.removeEventListener('keydown', this.onKey);

      setTimeout(function () {
        if (!d.classList.contains('is-open')) d.hidden = true;
      }, 300);
    }
  }

  customElements.define('vt-bottom-nav', VTBottomNav);
})();